/**
 * @generated SignedSource<<810fefd5e6eb61a246bd2dc6d42f3aa5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useCompareAddressAutocompleteQuery$variables = {
  query: string;
};
export type useCompareAddressAutocompleteQuery$data = {
  readonly landlordAutocompleteAddresses: ReadonlyArray<{
    readonly id: string;
    readonly label: string | null | undefined;
  }> | null | undefined;
};
export type useCompareAddressAutocompleteQuery = {
  response: useCompareAddressAutocompleteQuery$data;
  variables: useCompareAddressAutocompleteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "LandlordAddressSuggestion",
    "kind": "LinkedField",
    "name": "landlordAutocompleteAddresses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompareAddressAutocompleteQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCompareAddressAutocompleteQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "ab9d87085450d05de9f8b3fa11806dad",
    "id": null,
    "metadata": {},
    "name": "useCompareAddressAutocompleteQuery",
    "operationKind": "query",
    "text": "query useCompareAddressAutocompleteQuery(\n  $query: String!\n) {\n  landlordAutocompleteAddresses(query: $query) {\n    id\n    label\n  }\n}\n"
  }
};
})();

(node as any).hash = "cef00011a82ae7aed00f59477faf9f0b";

export default node;
